import { useSEO } from '@/hooks/useSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotTopicsGrid from './components/HotTopicsGrid';
import DeepDiveSection from './components/DeepDiveSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  useSEO({
    title: '51爆料 - 今日热点大瓜独家速报 | 网红翻车擦边反差 | 吃瓜爆料黑料第一站实时热点',
    description:
      '51爆料今日热点大瓜独家速报，网红翻车、擦边反差、明星八卦黑料24小时实时更新。作为吃瓜爆料黑料第一站，深度解读每一个热门事件，真实内幕不遮掩，立即进入查看最新爆料！',
    keywords:
      '51爆料,今日大瓜,网红翻车,擦边内容,网红反差,吃瓜黑料,爆料第一站,热点事件,独家速报,黑料曝光',
    url: 'https://www.51baoliao.com/',
    type: 'website',
    image: 'https://www.51baoliao.com/og-image.jpg',
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotTopicsGrid />
        <DeepDiveSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}